import React from "react";
import { Reveal, GoldDivider, SectionHeading } from "./Atoms";

const About = () => {
  return (
    <section id="about" className="relative py-28 px-6 bg-[#050505]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <SectionHeading
              overline="About the Ministry"
              title={<>About <span className="italic gold-text">Revival Fire</span> Ministries Global</>}
            />
          </Reveal>
          <Reveal delay={100}>
            <div className="relative pl-6 border-l border-[#C9A44C]/40">
              <p className="font-serif-display italic text-2xl sm:text-3xl text-[#F6F0E6] leading-snug">
                “For our God is a consuming fire.”
              </p>
              <p className="mt-3 text-[#C9A44C] text-sm tracking-[0.18em] uppercase">
                Hebrews 12:29 · KJV
              </p>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 space-y-6">
          <Reveal>
            <p className="text-[#D9D9D9] text-base sm:text-[17px] leading-relaxed">
              Revival Fire Ministries Global is a prophetic and apostolic holiness revival
              movement commissioned to draw hearts back to Jesus Christ through the
              preaching and teaching of the unadulterated Word of God with power and
              demonstration of the Spirit of God.
            </p>
          </Reveal>
          <Reveal delay={80}>
            <p className="text-[#D9D9D9] text-base sm:text-[17px] leading-relaxed">
              The ministry carries a burden for repentance, holiness, prayer, fasting,
              consecration, deliverance, healing, discipleship, evangelism, signs,
              wonders, miracles, Fire Hubs, Revival Hubs, and the fire of the Holy Ghost.
            </p>
          </Reveal>
          <Reveal delay={160}>
            <p className="text-[#F6F0E6] text-base sm:text-[17px] leading-relaxed">
              This is a call back to Jesus, back to the altar, back to the Word,
              back to holiness, and back to the fire of God.
            </p>
          </Reveal>

          <Reveal delay={240}>
            <div className="mt-8">
              <GoldDivider />
              <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
                {[
                  ["Repentance", "Back to the altar"],
                  ["Holiness", "Set apart unto God"],
                  ["Prayer", "Travail until breakthrough"],
                  ["Fire", "The Holy Ghost"],
                ].map(([t, s]) => (
                  <div key={t} className="px-4">
                    <div className="font-serif-display text-2xl text-[#F6F0E6]">{t}</div>
                    <div className="mt-1 text-xs tracking-[0.18em] uppercase text-[#C9A44C]/80">{s}</div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
